export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_6.9ccbe631.jpg";